import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchChatbots } from "../redux/store/chatbotSlice";
import { FiPlus } from "react-icons/fi";

export default function ChatbotRedirect() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const { chatbots, loading } = useSelector((s) => s.chatbots);

  useEffect(() => {
    dispatch(fetchChatbots());
  }, [dispatch]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[60vh] text-gray-400 text-sm">
        Loading chatbots…
      </div>
    );
  }

  if (chatbots.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[60vh] text-center px-6">
        <div className="text-5xl mb-4">🤖</div>
        <h2 className="text-xl font-semibold text-gray-800 mb-2">Create your first chatbot</h2>
        <p className="text-sm text-gray-500 mb-6 max-w-xs">
          Train an AI chatbot on your website, documents, or any content — and embed it anywhere in minutes.
        </p>
        <button
          onClick={() => navigate("/chatbot/create")}
          className="flex items-center gap-2 bg-primary text-white px-5 py-2.5 rounded-lg font-medium hover:opacity-90 transition"
        >
          <FiPlus size={16} /> Create chatbot
        </button>
      </div>
    );
  }

  // Navigate imperatively so we can use the correct field name
  const firstId = chatbots[0].id;
  navigate(`/overview/${firstId}`, { replace: true });
  return null;
}
